import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";
import { Container, Icon, Label } from "./styles";

export type OpenSearchProps = {
  handleOpen: () => void;
};

const OpenSearch: React.FC<OpenSearchProps> = (props) => {
  const { handleOpen } = props;
  const { locale = "it" } = useRouter();
  const label = useTranslation("productListing.searchButton", locale);

  return (
    <Container role="button" onClick={() => handleOpen()}>
      <Label>{label || "Codice prodotto"}</Label>
      <Icon />
    </Container>
  );
};

export default OpenSearch;
